import { Box, BoxProps, styled } from '@mui/material';
import clsx from 'clsx';
import React, { ReactElement } from 'react';

export interface ClickBoxProps extends BoxProps {}

export const ClickBox = styled(
  ({ className, ...boxProps }: ClickBoxProps): ReactElement => {
    return (
      <Box
        className={clsx('keyboardFocus', className)}
        tabIndex={0}
        {...boxProps}
      />
    );
  },
)(({ theme }) => ({
  borderRadius: 8,
  cursor: 'pointer',
  '&:hover': {
    background: theme.palette.neutral.light,
  },
  '&:focus-visible': {
    outlineOffset: 0,
  },
}));
